import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

interface SidebarState {
  activeMenuId: string
}

const initialState: SidebarState = {
  activeMenuId: "dashboard",
}

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setActiveMenuId: (state, action: PayloadAction<string>) => {
      state.activeMenuId = action.payload
    },
  },
})

export const { setActiveMenuId } = sidebarSlice.actions
export default sidebarSlice.reducer

